module.exports = __webpack_public_path__ + "img/jcr-book-cover.7dfcf872.jpg";